export const Logo = () => {
  return (
    <svg
      width={59}
      height={59}
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 9.362c.128-.65.228-1.307.388-1.948C1.51 2.906 5.722-.01 9.84.002 22.886.04 35.932.046 48.978 0c4.781-.017 9.137 3.717 9.716 8.488.055.46.099.926.1 1.39.005 12.98.004 25.96.004 38.94 0 5.537-4.26 9.87-9.799 9.96-1.124.019-2.25.003-3.446.003.521-.958 1.022-1.808 1.456-2.692 1.295-2.642 1.905-5.441 1.9-8.387-.012-6.794-.004-13.588-.004-20.383 0-9.204-6.275-17.306-15.23-19.378-6.662-1.541-12.546.241-17.523 4.882-3.275 3.053-5.2 6.886-5.935 11.3a20.58 20.58 0 00-.262 3.143c-.033 3.163-.015 6.328-.011 9.491.008 6.708 4.874 12.457 11.48 13.538.835.137 1.689.216 2.534.22 5.084.02 10.169.009 15.253.009h.892c-.289.759-.477 1.458-.807 2.083-1.874 3.553-4.78 5.65-8.812 6.015-1.467.133-2.951.098-4.428.105-5.286.026-10.573-.014-15.858.069-5.023.08-9.183-3.524-9.992-8.207L0 49.403V9.363z"
        fill="#00DAEE"
        fillOpacity={0.47}
      />
      <path
        d="M31.447 41.985c-2.553 0-5.107-.056-7.657.015-2.945.082-5.348-2.513-5.3-5.256.059-3.365-.055-6.735.043-10.099.144-4.96 3.805-9.916 9.54-10.654 5.7-.734 11.246 3.484 12.13 9.167.097.618.153 1.248.155 1.873.013 4.725-.003 9.45.02 14.176.003.614-.171.798-.788.791-2.714-.03-5.43-.013-8.143-.013z"
        fill="#00DAEE"
        fillOpacity={0.47}
      />
    </svg>
  );
};
